var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import Immutable from 'immutable';

import { Map, Markers } from "../../Map";
import { TemplateLabel } from "../../Layout";
import {
getAndSelectDocument,
selectDocuments,
unselectAllDocuments } from "../../Library/actions/libraryActions";

import { wrapDispatch } from "../../Multireducer";

import { Loader } from "../../components/Elements/Loader";
import markdownDatasets from "../markdownDatasets";

const renderInfo = (marker) => /*#__PURE__*/
_jsx("div", {}, void 0, /*#__PURE__*/
_jsx(TemplateLabel, { template: marker.properties.entity.template }), "\xA0 ",
marker.properties.entity.title);



export const MapComponent = (props) => {
  const { data, classname, scrollZoom, showControls } = props;
  const clickOnMarker = (marker) => props.getAndSelectDocument(marker.properties.entity.sharedId);
  const clickOnCluster = (cluster) => {
    props.unselectAllDocuments();
    props.selectDocuments(cluster.map((m) => m.properties.entity));
  };

  return /*#__PURE__*/(
    _jsx("div", { className: `Map ${classname}` }, void 0,
    data ? /*#__PURE__*/
    _jsx(Markers, { entities: data }, void 0,
    (markers) => /*#__PURE__*/
    _jsx(Map, {
      markers: markers,
      zoom: 1,
      clickOnMarker: clickOnMarker,
      clickOnCluster: clickOnCluster,
      renderPopupInfo: renderInfo,
      cluster: true,
      scrollZoom: scrollZoom === 'true',
      showControls: showControls === 'true' })) : /*#__PURE__*/




    _jsx(Loader, {})));



};

MapComponent.defaultProps = {
  classname: '',
  data: null,
  scrollZoom: null,
  showControls: null
};











export const mapStateToProps = (state, props) => ({
  data: markdownDatasets.getRows(state, props)
});

export const mapDispatchToProps = (dispatch) =>
bindActionCreators(
{ getAndSelectDocument, selectDocuments, unselectAllDocuments },
wrapDispatch(dispatch, 'library'));


export default connect(mapStateToProps, mapDispatchToProps, null)(MapComponent);